module.exports = __webpack_public_path__ + "assets/img/36_570_big.5deaef83.jpg";